import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { if: "title" }
const _hoisted_2 = ["xlink:href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _mergeProps({
    class: ["icon", $props.fill != '' ? 'fill-' + $props.fill : '']
  }, _ctx.$attrs), [
    _createElementVNode("title", _hoisted_1, _toDisplayString($props.title), 1),
    _createElementVNode("use", {
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "xlink:href": '#icon-' + $props.name
    }, null, 8, _hoisted_2)
  ], 16))
}